"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVisibleAreaAbsoluteValues = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../../utils");
var to_pointer_pos_on_img_1 = require("../../functions/convert/to-pointer-pos-on-img");
var useVisibleAreaAbsoluteValues = function (canvasRectSizeAbsolute$, onMouseMove$, onMouseLeave$, bgMinPaddingPx) {
    // キャンバスの左上を原点としたときの画像表示領域を表す長方形
    var imgVisibleAreaRectAbsolute$ = (0, utils_1.useDataStream)((0, utils_1.IRect)(), canvasRectSizeAbsolute$.pipe((0, operators_1.map)(function (canvasRectSize) {
        return (0, utils_1.IRect)({
            top: bgMinPaddingPx,
            left: bgMinPaddingPx,
            width: canvasRectSize.width - 2 * bgMinPaddingPx,
            height: canvasRectSize.height - 2 * bgMinPaddingPx
        });
    }), (0, operators_1.filter)(utils_1.isValidRect)));
    /**
     * @description 画像表示領域の左上を原点としたときのポインタ位置
     */
    var pointerPosOnImgVisibleAreaAbsolute$ = (0, utils_1.useDataStream)(undefined, (0, utils_1.mergeTyped)(onMouseLeave$.pipe((0, operators_1.mapTo)(undefined)), onMouseMove$.pipe((0, utils_1.filterNotUndefined)(), (0, operators_1.withLatestFrom)(imgVisibleAreaRectAbsolute$.pipe((0, operators_1.map)(to_pointer_pos_on_img_1.toPointerPosOnVisibleArea))), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), pointerPos = _b[0], toPointerPosOnVisibleAreaFn = _b[1];
        return toPointerPosOnVisibleAreaFn(pointerPos);
    }))));
    return {
        imgVisibleAreaRectAbsolute$: imgVisibleAreaRectAbsolute$,
        pointerPosOnImgVisibleAreaAbsolute$: pointerPosOnImgVisibleAreaAbsolute$
    };
};
exports.useVisibleAreaAbsoluteValues = useVisibleAreaAbsoluteValues;
